// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"587cec44","513":"f2fd008f","703":"a18eb93e"}[chunkId] + ".chunk.js";
};